export default __webpack_public_path__ + "static/content1-b5557d7fc4319524467291383188ddff.jpg";